import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import { initializeFaro } from '@grafana/faro-web-sdk';

// 5/8 신규 = arcus portal RUM (Real User Monitoring) 답습
// 답습 = service-springboot-fe-gradle (5/5 commit bdc820e9) Faro endpoint 답습
const faroUrl =
  (window as any).__ARCUS_FARO_URL__ ||
  'https://grafana.dev.arcus-platform.com/faro/collect';
const faroEnv = window.location.host.startsWith('cloudops-dev')
  ? 'dev'
  : 'production';

if (faroUrl) {
  initializeFaro({
    url: faroUrl,
    app: {
      name: 'arcus-portal',
      version: '1.0.0',
      environment: faroEnv,
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
